import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageRefService } from './local-storage-ref.service';

@Injectable({ providedIn: 'root' })
export class CookiesService {
  private _localStorage: Storage;

  private _consent_for_cookies$ = new BehaviorSubject<any>(null);
  public consent_for_cookies$ = this._consent_for_cookies$.asObservable();

  constructor(private _localStorageRefService: LocalStorageRefService) {
    this._localStorage = _localStorageRefService.localStorage;
    this.loadConsentCookie();
  }

  acceptCookiesConsent() {
    this._localStorage.setItem('accepts_cookies', 'true');
    this._consent_for_cookies$.next('true');
  }

  loadConsentCookie() {
    const consentCookie = this._localStorage.getItem('accepts_cookies');
    this._consent_for_cookies$.next(consentCookie);
  }

  clearAllLocalStorage() {
    this._localStorage.clear();
    this._consent_for_cookies$.next(null);
  }
}
